import {Component, Input, ContentChild, OnInit, ViewChild, TemplateRef, forwardRef} from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControlDirective, NG_VALUE_ACCESSOR, FormGroup } from '@angular/forms';
import { BaseUiFormControl } from '../base-ui-form-control';

@Component({
  selector: 'ui-checkbox',
  templateUrl: './ui-checkbox.component.html',
  styleUrls: ['./ui-checkbox.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting:  forwardRef(() => UiCheckboxComponent),
    multi: true
  }]
})
export class UiCheckboxComponent extends BaseUiFormControl implements ControlValueAccessor, OnInit {
  @Input() readOnly: boolean = false;
  @Input() isPrimeNg: boolean = false;
  @Input() cssClass: string = '';
  @Input() formGroupClassName: string = '';
  @Input() set options(value: string) {
    this.checkboxOptions = value.split(';');
  }

  //@ViewChild('viewTemplate') viewTemplate: TemplateRef<any>;
  //@ViewChild('editTemplate') editTemplate: TemplateRef<any>;

  parentFormGroup: FormGroup;
  checkboxOptions: string[] = [];

  constructor(controlContainer: ControlContainer) {
    super(controlContainer);
  }

  ngOnInit() {
    this.parentFormGroup = this.controlContainer.control as FormGroup;
  }

  registerOnTouched(fn: any): void {
  }

  registerOnChange(fn: any): void {
  }

  writeValue(obj: any): void {
  }

  setDisabledState(isDisabled: boolean): void {

  }

  isPrimeng() {
    return this.isPrimeNg || this.optionExists('usePrimeng');
  }

  optionExists(value) {
    return this.checkboxOptions.indexOf(value) > -1;
  }
}
